import { Fragment, useState, useMemo } from 'react';
import {
    SimpleForm, useTranslate, Toolbar, SaveButton,
    Button, ReferenceArrayInput,
    useNotify, useRefresh, AutocompleteArrayInput,
    TextInput,
    CheckboxGroupInput,
} from 'react-admin';
import axios from 'axios';
import { makeStyles } from '@mui/styles';
import { Link } from '@material-ui/icons';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { ViewTitle } from '../../components';
import { Cancel } from '@mui/icons-material';
import handleError from '../../components/handleError';
import { useEffect } from 'react';
import { useRef } from 'react';

const useStyles = makeStyles((theme) => ({
    toolbar: {
        display: 'flex',
    },
    spacer: {
        flex: 1,
    },
    buttonMarginLeft: {
        marginLeft: 10
    },
    flexBox: {
        width: 'auto',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    inputMarginLeft: {
        marginLeft: 20
    },
    border: {
        border: '1px solid #6b489d'
    },
    inputWidth: {
        width: 400,
        minWidth: 300
    },
}));

const Validate = (values) => {
    const errors = {};
    if (!values.users) errors.users = 'ra.validation.required';
    return errors;
};

const AssociateUserToPod = ({ permissions }) => {
    const classes = useStyles();
    const translate = useTranslate();
    const [showDialog, setShowDialog] = useState(false);
    const notify = useNotify();
    const refresh = useRefresh();


    const [emailSearch, setEmailSearch] = useState('');
    const [firstnameSearch, setFirstnameSearch] = useState('');
    const [lastnameSearch, setLastnameSearch] = useState('');


    const hasSearch = emailSearch?.trim() || firstnameSearch?.trim() || lastnameSearch?.trim();

    const combinedFilter = useMemo(() => {

        // Return impossible filter when no search input = no results shown
        if (!hasSearch) return { id: '__no_results__' };

        const f = { roles: 'trainee' };
        if (emailSearch?.trim()) f.email = emailSearch.trim();
        if (firstnameSearch?.trim()) f.firstname = firstnameSearch.trim();
        if (lastnameSearch?.trim()) f.lastname = lastnameSearch.trim();

        return f;
    }, [emailSearch, firstnameSearch, lastnameSearch]);


    const AssociateUser = async (data) => {
        const users = data.users;
        users.forEach(async (user) => {
            try {
                const options = {
                    headers: {},
                };

                const sendData = {
                    pod: data.id
                };

                const token = localStorage.getItem('token');
                options.headers.Authorization = `Bearer ${token}`;

                const res = await axios.post(`/api/v1/users/${user}/associate`, sendData, options);
                if (res.status !== 200) {
                    notify(translate('app.pods.associate.errorMessage'), { type: 'error' });
                }
                else {
                    notify(translate('app.pods.associate.successMessage'), { type: 'success' });
                    handleCloseClick();
                    refresh();
                };
            }
            catch (error) {
                handleError(error, notify);
            }
        });
    }


    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
        setEmailSearch('');
        setFirstnameSearch('');
        setLastnameSearch('');
    };

    const fullNameField = choice => `${choice.firstname} ${choice.lastname} (${choice.email})`;
    const CreateToolbar = (props) => {
        const classes = useStyles();
        const translate = useTranslate();
        return (
            <Toolbar className={classes.toolbar}>
                <Button label="ra.action.cancel" size="medium" onClick={handleCloseClick} className={classes.border} >
                    <Cancel />
                </Button>
                <SaveButton label={translate('app.buttons.send')} className={classes.buttonMarginLeft} />
            </Toolbar>
        );
    };

    // const filterToQuery = searchText => ({ email: `${searchText}` });

    // const filterToQuery = (searchText) => ({
    //     $or: [
    //         { email: searchText },
    //         { firstname: searchText },
    //         { lastname: searchText },
    //     ],
    // });

    return (
        <Fragment>
            <Button label={translate('app.pods.associate.button')} onClick={handleClick}><Link /></Button>
            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label={translate('app.pods.associate.title')}
            >
                <DialogTitle><ViewTitle label={translate('app.pods.associate.title')} icon={Link} /></DialogTitle>
                <DialogContent>
                    <SimpleForm validate={Validate} toolbar={<CreateToolbar />}
                        onSubmit={AssociateUser} >

                        <div style={{ display: 'flex', marginBottom: 16, color: '#666' }}>
                            {translate('app.pods.associate.searchByEmailBis')}
                        </div>


                        <div style={{ display: 'flex', gap: 12 }}>
                            <TextInput
                                label="Email"
                                source="emailSearch"
                                value={emailSearch}
                                onChange={(e) => setEmailSearch(e.target.value)}
                            />
                            <TextInput
                                label="Firstname"
                                source="firstnameSearch"
                                value={firstnameSearch}
                                onChange={(e) => setFirstnameSearch(e.target.value)}
                            />
                            <TextInput
                                label="Lastname"
                                source="lastnameSearch"
                                value={lastnameSearch}
                                onChange={(e) => setLastnameSearch(e.target.value)}
                            />
                        </div>

                        <ReferenceArrayInput
                            source="users"
                            reference="users"
                            filter={combinedFilter}   // your AND filter
                            label={translate('app.pods.associate.user')}
                        >
                            {/* <AutocompleteArrayInput
                                optionText={fullNameField}
                                filterToQuery={() => ({})}
                                // options={{ openOnFocus: true, autoHighlight: true }}
                                label={translate('app.pods.associate.user')}
                                componentsProps={{
                                    popper: {
                                        modifiers: [{ name: 'flip', enabled: false }]
                                    }
                                }}
                                // open
                                // disablePortal   
                                className={classes.inputWidth}
                                // inputProps={{
                                //     readOnly: true,
                                //     style: { cursor: 'default' }
                                // }}
                                TextFieldProps={{
                                    disabled: true,
                                    style: { display: 'true' }  // or just disabled: true to keep it visible but unusable
                                }} */}
                            <CheckboxGroupInput
                                optionText={fullNameField}
                                sx={{
                                    '& .MuiFormGroup-root': {
                                        maxHeight: '250px',
                                        overflowY: 'auto',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '4px',
                                        padding: '8px'
                                    }
                                }}
                            />
                        </ReferenceArrayInput>

                    </SimpleForm>
                </DialogContent>
            </Dialog>
        </Fragment>
    );
};

export default AssociateUserToPod;

